module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Back",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "el-icon-back",
    staticStyle: {
      "font-size": "4rem",
      "padding": "3px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.handleBack
    }
  })])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Setup",
      "name": "setup"
    }
  }, [_c('setup-tab')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Canvas",
      "name": "canvas",
      "disabled": !_vm.survey.id
    }
  }, [_c('canvas-tab')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Preview & Publish",
      "name": "preview",
      "disabled": !_vm.survey.id
    }
  }, [_c('preview-tab', {
    ref: "previewTab"
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Survey Builder")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfe73864","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/SurveyBuilderEditor.vue
// module id = 3407
// module chunks = 3